module.exports = __webpack_public_path__ + "media/images/e-bilet/about/sale-a55ebb9a05bf600cd7443b37366f0222.svg";